import React from 'react';
import { Segmented } from 'antd';
import { BasemapType } from '../types';

interface Props {
    value: BasemapType;
    onChange: (next: BasemapType) => void;
    /** 距地图右边缘的距离 (px); 属性抽屉打开时要让开抽屉宽度, 否则被压在抽屉底下。 */
    rightOffset?: number;
}

const OPTIONS: { value: BasemapType; label: string }[] = [
    { value: 'osm', label: 'OSM' }, // 默认: 直连瓦片 CDN, 不依赖 Google JS API
    { value: 'satellite', label: '卫星图' }, // Google hybrid (卫星影像 + 路名)
    { value: 'google', label: 'Google' },
];

/** 地图右上角底图三选 —— antd Segmented, 与项目其他分段切换控件一致。 */
const BasemapSwitcher: React.FC<Props> = ({ value, onChange, rightOffset = 12 }) => (
    <div
        className="absolute rounded-lg bg-white p-1 shadow-md"
        style={{ top: 12, right: rightOffset, zIndex: 1200 }}
    >
        <Segmented<BasemapType>
            size="small"
            value={value}
            options={OPTIONS}
            onChange={(next) => onChange(next)}
        />
    </div>
);

export default BasemapSwitcher;
